module.exports = __webpack_public_path__ + "static/media/home-comp-logos-henry.b7fd4637.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-comp-logos-henry.png
// module id = 272
// module chunks = 0